(() => {
  'use strict';
  let timer;
  const expire = () => {
    window.clearTimeout(timer);
    const now = Date.now();
    let next = 60000;
    document.querySelectorAll('[data-amazon-offer]').forEach((offer) => {
      const remaining = Number(offer.dataset.amazonExpires) - now;
      if (remaining > 0) {
        next = Math.min(next, remaining);
        return;
      }
      offer.querySelectorAll('[data-amazon-current]').forEach((node) => node.remove());
      offer.querySelectorAll('[data-amazon-fallback]').forEach((node) => { node.hidden = false; });
    });
    document.querySelectorAll('[data-amazon-rating]').forEach((rating) => {
      const remaining = Number(rating.dataset.amazonExpires) - now;
      if (remaining > 0) {
        next = Math.min(next, remaining);
        return;
      }
      rating.remove();
    });
    document.querySelectorAll('[data-amazon-image]').forEach((image) => {
      const remaining = Number(image.dataset.amazonExpires) - now;
      if (remaining > 0) {
        next = Math.min(next, remaining);
        return;
      }
      const fallback = image.parentElement.querySelector('[data-amazon-image-fallback]');
      image.remove();
      if (fallback) fallback.hidden = false;
    });
    timer = window.setTimeout(expire, next);
  };
  expire();
  document.addEventListener('visibilitychange', expire);
  document.addEventListener('shopify:section:load', expire);
})();
